export enum UserRole {
    ReadOnly = 1,
    Basic = 2,
    Admin = 4,
    SuperAdmin = 8
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/userRole.ts